import http from '@/libs/axios'

export function excelUpload(data) {
  return http({
    method: 'GET',
    url: '/objects/reports/',
    params: {
      excel: true,
      ...data,
    },
    timeout: 0,
    responseType: 'blob',
  })
}

export function getObjects(params) {
  return http.get('objects/', { params })
}
export function getOverallTable(params) {
  return http({
    method: 'GET',
    url: '/objects/report_by_object/',
    params,
  })
}
export function getSoldFlat(params) {
  return http({
    method: 'GET',
    url: '/objects/report_manager/',
    params,
  })
}
export function getAllClientsTable(params) {
  return http({
    method: 'GET',
    url: '/objects/report_transactions_by_payment/',
    params,
  })
}
export function getAllClientsByIcome(params) {
  return http({
    method: 'GET',
    url: '/objects/report_transactions_by_income/',
    params,
  })
}
export function getNotSoldFlat(params) {
  return http({
    method: 'GET',
    url: '/objects/report_not_sold_flats/',
    params,
  })
}
export function getShortObjects(params) {
  return http({
    method: 'GET',
    url: 'objects',
    params,
  })
}

export function getSingleObject(id) {
  return http.get(`objects/${id}/`)
}

export function createObject(data) {
  return http.post('objects/', data)
}

export function updateObject(data) {
  return http.patch(`objects/${data.id || data.get('id')}/`, data, { timeout: 0 })
}

export function getObjectTypes(params) {
  return http.get('objects/types/', { params })
}

export function getInfrastructures() {
  return http.get('objects/infrastructures/')
}

export function getParkingOptions() {
  return http({
    method: 'GET',
    url: '/objects/parking/',
  })
}

export function deleteMediaFile(id) {
  return http({
    method: 'DELETE',
    url: `objects/${id}/delete_media`,
  })
}

export function getObjectCalculations(id) {
  return http({
    method: 'GET',
    url: `/objects/${id}/discount/`,
  })
}

export function createObjectCalculationItem(data) {
  return http({
    method: 'POST',
    url: '/objects/discount-percent/',
    data,
  })
}

export function updateObjectCalculationItem(data) {
  return http({
    method: 'PATCH',
    url: `/objects/discount-percent/${data.id}/`,
    data,
  })
}

export function getConstructionProgress(id) {
  return http({
    method: 'GET',
    url: `/objects/${id}/construction/`,
  })
}

export function createConstructionProgress(data) {
  return http({
    method: 'POST',
    url: '/objects/construction/',
    data,
  })
}
export function lastOvrallTable({ data, id }) {
  return http({
    method: 'get',
    url: `/clients/report_contract/${id}`,
    params: data,
  })
}

export function getObjectPriceHistory(params) {
  return http({
    method: 'GET',
    url: `/objects/${params.id}/stage_history/`,
    params,
  })
}

export function getObjectDiscountHistory(params) {
  return http({
    method: 'GET',
    url: `/objects/${params.id}/discount_percent_history/`,
    params,
  })
}

export function getPaymentTypes() {
  return http({
    method: 'GET',
    url: 'objects/payment-type-object/',
  })
}

export function getOnePaymentType(id) {
  return http({
    method: 'GET',
    url: `/objects/payment-type-object/${id}/`,
  })
}

export function getReportsTable(data) {
  return http({
    method: 'GET',
    url: '/objects/report/',
    data,
  })
}

export function getRelatedPerson(params) {
  return http({
    method: 'GET',
    url: '/objects/related_person/report/',
    params,
  })
}

// export function getObjectContractsReport(id) {
//   return http({
//     method: 'GET',
//     url: `/objects/${id}/reports/`,
//   })
// }

export function getObjectContractsReport(params) {
  return http({
    method: 'GET',
    url: '/objects/reports/',
    params,
  })
}
